import { Button } from "@components/atoms/Button"
import { ScrollReveal } from "@components/motion/Transitioned"
import { FlowgramImage } from "@components/site/FlowgramImage"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link, useRoute } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Case Study Grid",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/case-study-grid", (props) => {
  let items = []
  if (props.type === "latest") {
    items = props.caseStudies?.nodes || []
  } else {
    items = props.selectedContent || []
  }

  const route = useRoute()

  return (
    <ScrollReveal className="w-grid mx-auto flex flex-col gap-7 py-7 my-10">
      <EditableText
        as="p"
        store="title"
        className="type-label-l md:type-label-xl"
        placeholder="Optional Title"
        data-transition
      />
      <div className="w-full flex flex-col gap-5">
        {env.admin && items.length === 0 && (
          <div className="w-full p-8 rounded-lg bg-grey flex items-center justify-center type-label-m" data-transition>
            Select content
          </div>
        )}
        {items.length > 0 && (
          <>
            <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-y-7" data-transition>
              {items.slice(0, 6).map(
                (item, index) =>
                  !!item && (
                    <Link
                      key={index}
                      href={item.uri}
                      className="group/link rounded-xl border-2 border-black p-7 md:w-[calc(100%+2px)] md:-ml-[1px] hover:rounded-lg transition-radius transition-nice"
                      data-transition="scale"
                    >
                      <div className="aspect-[1/0.74] flex flex-col gap-4 justify-between group-hover/link:scale-[1.01] transition-transform transition-nice">
                        <div className="flex flex-col gap-4">
                          <p className="type-label-s-caps" data-transition="fade-up">
                            Case Study
                          </p>
                          <p className="type-title-m" data-transition="fade-up">
                            {item.title}
                          </p>
                        </div>

                        {/* details */}
                        <div className="flex gap-4 items-end w-full self-end transition-nice">
                          <p className="type-label-m text-balance" data-transition="fade-up">
                            {item.pageHeaderCaseStudy?.subtitle}
                          </p>
                          {item.pageHeaderCaseStudy?.flowgramImage && (
                            <FlowgramImage
                              flowgramImage={item.pageHeaderCaseStudy?.flowgramImage}
                              className="shrink-0 w-[4em]"
                              strokeHeavy
                            />
                          )}
                        </div>
                      </div>
                    </Link>
                  ),
              )}
            </div>
            {(items.length > 6 || props.showViewMoreButton) && (
              <div className="flex justify-end">
                <Button
                  href={route.view === "template-work" ? route.pathname + "?mode=all" : "/work"}
                  className="self-end"
                  data-transition
                  variant="inverted"
                >
                  View more
                </Button>
              </div>
            )}
          </>
        )}
      </div>
    </ScrollReveal>
  )
})
